import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { isCatanHost } from './core/services/subdomain.service';

/** Na catan.my-famil.io je scoreboard početna; drugdje ostaje obiteljski dashboard. */
const defaultRoute = () => (isCatanHost() ? '/catan' : '/dashboard');

export const routes: Routes = [
  {
    path: 'landing',
    loadComponent: () => import('./features/landing/landing-page.component').then(m => m.LandingPageComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent),
  },
  // Registracija je onemogućena — korisnici se kreiraju putem admin panela
  // {
  //   path: 'register',
  //   loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent),
  // },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
  },
  {
    path: 'calendar',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/calendar/calendar-page/calendar-page.component').then(m => m.CalendarPageComponent),
  },
  {
    path: 'projects',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/projects/projects-page/projects-page.component').then(m => m.ProjectsPageComponent),
  },
  {
    path: 'receipts',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/receipts/receipts-page/receipts-page.component').then(m => m.ReceiptsPageComponent),
  },
  {
    path: 'uplatnice',
    canActivate: [authGuard],
    loadComponent: () => import('./features/bills/bills-page/bills-page.component').then(m => m.BillsPageComponent),
  },
  {
    path: 'media',
    canActivate: [authGuard],
    loadComponent: () => import('./features/media/media-page/media-page.component').then(m => m.MediaPageComponent),
  },
  {
    path: 'shopping',
    canActivate: [authGuard],
    loadComponent: () => import('./features/shopping/shopping-page.component').then(m => m.ShoppingPageComponent),
  },
  {
    path: 'budget',
    canActivate: [authGuard],
    loadComponent: () => import('./features/budget/budget-page.component').then(m => m.BudgetPageComponent),
  },
  {
    path: 'chores',
    canActivate: [authGuard],
    loadComponent: () => import('./features/chores/chores-page.component').then(m => m.ChoresPageComponent),
  },
  {
    path: 'meal-reminders',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/meal-reminders/meal-reminders-page.component').then(m => m.MealRemindersPageComponent),
  },
  {
    path: 'notes',
    canActivate: [authGuard],
    loadComponent: () => import('./features/notes/notes-page.component').then(m => m.NotesPageComponent),
  },
  {
    path: 'cameras',
    canActivate: [authGuard],
    loadComponent: () => import('./features/cameras/cameras-page.component').then(m => m.CamerasPageComponent),
  },
  {
    path: 'special-dates',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/special-dates/special-dates-page.component').then(m => m.SpecialDatesPageComponent),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./features/profile/profile-page.component').then(m => m.ProfilePageComponent),
  },
  {
    path: 'family',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/family/family-page/family-page.component').then(m => m.FamilyPageComponent),
      },
      {
        path: 'create',
        loadComponent: () =>
          import('./features/family/create/create-family.component').then(m => m.CreateFamilyComponent),
      },
      {
        path: 'join',
        loadComponent: () => import('./features/family/join/join-family.component').then(m => m.JoinFamilyComponent),
      },
      {
        path: ':id/members',
        loadComponent: () =>
          import('./features/family/members/family-members.component').then(m => m.FamilyMembersComponent),
      },
    ],
  },
  {
    path: 'admin',
    canActivate: [authGuard, adminGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/admin/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/admin/admin-users/admin-users.component').then(m => m.AdminUsersComponent),
      },
      {
        path: 'families',
        loadComponent: () =>
          import('./features/admin/admin-families/admin-families.component').then(m => m.AdminFamiliesComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/admin/admin-settings/admin-settings.component').then(m => m.AdminSettingsComponent),
      },
    ],
  },
  // Catan scoreboard (catan.my-famil.io) — čitanje je javno, bez authGuarda.
  {
    path: 'catan',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/catan/scoreboard/catan-scoreboard.component').then(m => m.CatanScoreboardComponent),
      },
      {
        path: 'games',
        loadComponent: () => import('./features/catan/games/catan-games.component').then(m => m.CatanGamesComponent),
      },
      {
        path: 'games/:id',
        loadComponent: () =>
          import('./features/catan/games/catan-game-detail.component').then(m => m.CatanGameDetailComponent),
      },
      {
        path: 'players',
        loadComponent: () =>
          import('./features/catan/players/catan-players.component').then(m => m.CatanPlayersComponent),
      },
      {
        path: 'players/:id',
        loadComponent: () =>
          import('./features/catan/players/catan-player-stats.component').then(m => m.CatanPlayerStatsComponent),
      },
    ],
  },
  {
    path: '',
    redirectTo: defaultRoute,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: defaultRoute,
  },
];
